import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {DialogMessage} from './dialog-message.model';

@Injectable()
export class DialogMessageService {

  private messages: DialogMessage[] = [];
  public newMessage: Subject<DialogMessage> = new Subject<DialogMessage>();

  constructor() {
    this.newMessage.subscribe(
      (snackMessage: DialogMessage) => {
        this.messages.push(snackMessage);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-messages/dialog-message.service.ts